interface EndpointCardProps {
  method: 'GET' | 'POST';
  path: string;
  description: string;
  auth?: boolean;
  id?: string;
}

const METHOD_COLORS: Record<string, string> = {
  GET: 'bg-emerald-500/15 text-emerald-400 border-emerald-500/30',
  POST: 'bg-sky-500/15 text-sky-400 border-sky-500/30',
};

const BORDER_COLORS: Record<string, string> = {
  GET: 'border-l-emerald-500/40',
  POST: 'border-l-sky-500/40',
};

export default function EndpointCard({ method, path, description, auth, id }: EndpointCardProps) {
  return (
    <div id={id} className={`scroll-mt-20 border-l-2 ${BORDER_COLORS[method]} pl-4 py-3 my-6`}>
      <div className="flex items-center gap-3 flex-wrap">
        <span className={`font-mono text-[10px] font-medium px-2.5 py-1 rounded-subtle border ${METHOD_COLORS[method]}`}>
          {method}
        </span>
        <code className="font-mono text-sm text-bone-white">{path}</code>
        {auth && (
          <span className="font-mono text-[9px] text-amber-400/70 border border-amber-400/20 px-2 py-0.5 rounded-subtle">
            AUTH
          </span>
        )}
      </div>
      <p className="font-sans text-sm text-bone-white/60 mt-2 leading-relaxed">{description}</p>
    </div>
  );
}
